module.exports = __webpack_public_path__ + "static/media/blog.82b4305b.jpg";